import accordionView from './accordionComponent.html';
import './accordionComponent.css';
import { AssetManager } from 'components/sharpr/assetManager/AssetManager.js';
import _ from 'lodash';

export function accordionComponent() {
	return {
		bindings: {
			duration: '<?',
			height: '<?',
			multiOpen: '<?',
		},
		controllerAs: 'vm',
		transclude: true,
		controller: accordionComponentCtrl,
		template: accordionView,
	};
}

export class accordionComponentCtrl {
	constructor($element) {
		'ngInject';
		this.$element = $element;
		// setup
		this.style = AssetManager.style('');
		this.id = 'Accordion' + _.uniqueId();
		this.panes = [];
		// defaults
		this.duration = typeof this.duration == 'number' ? this.duration : 250;
		this.height = typeof this.height == 'number' ? this.height : 300;
		this.multiOpen = !!this.multiOpen;
	}

	$onChanges(changes) {
		if (changes.height || changes.duration) {
			this.buildStyles();
		}
	}

	$onDestroy() {
		this.style.parentNode.removeChild(this.style);
	}

	// called from accordionPaneComponent
	paneClick(vm) {
		if (vm.isOpen && !this.multiOpen) {
			// already open
			return;
		} else if (this.multiOpen) {
			// toggle this one pane
			vm.isOpen = !vm.isOpen;
		} else {
			// open only this one pane
			this.panes.forEach(pane => (pane.isOpen = pane === vm));
		}
	}

	registerPane(pane) {
		this.panes.push(pane);
	}

	unregisterPane(pane) {
		const idx = this.panes.indexOf(pane);
		this.panes.splice(idx, 1);
	}

	buildStyles() {
		// wait for DOM to render so our height calculation will be correct
		setTimeout(() => {
			let height;
			if (this.height === 0) {
				// auto height
				height = 'auto';
			} else if (this.height < 0) {
				// use a negative number to fill up all but the given padding in the parent node
				height =
					this.$element[0].parentNode.getBoundingClientRect().height +
					this.height -
					this.$element[0].children[0].getBoundingClientRect().height -
					30; // padding of inner pane
				height += 'px';
			} else {
				height = this.height;
				height += 'px';
			}
			this.style.textContent = `
				#${this.id} sh-accordion-pane .is-open .pane-content { height: ${height} }
				#${this.id} sh-accordion-pane .pane-content,
				#${this.id} sh-accordion-pane .icons { transition-duration: ${this.duration}ms }
			`;
		}, 0);
	}
}
